import modelBase from '../../models/model-base.model';

var announcementModel = {
  getAnnouncementList: function (successCallBack, failureCallBack, filter) {
    var path = '/api/announcement?FromDate=' + filter.fromDate + '&ToDate=' + filter.toDate + '&title=' + filter.title + '&pageIndex=' + filter.pageIndex + '&pageSize=' + filter.pageSize;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getAnnouncementRecipients: function (successCallBack, failureCallBack, announcementId, statusCode, pageIndex, pageSize, user) {
    var path = '/api/announcement/recipientlist?AnnouncementId=' + announcementId + '&StatusCode=' + statusCode + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize + '&UserIDOrName=' + user;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  announcementUploadMultipleFiles: function (successCallBack, failureCallBack, formData) {
    var path = '/api/retail/file/Announcement/multiple';
    modelBase.post(successCallBack, failureCallBack, path, { body: formData });
  },
  announcementChangeStatus: function (successCallBack, failureCallBack, announcementId, statusCode) {
    var params = {};
    params.announcementId = announcementId;
    params.statusCode = statusCode;
    var path = '/api/announcement/update';
    modelBase.post(successCallBack, failureCallBack, path, { body: params });
  },
  announcementSave: function (successCallBack, failureCallBack, userList, fileList, title, content) {
    var params = {};
    params.userID = userList;
    params.fileMasterID = fileList;
    params.title = title;
    params.content = content;
    var path = '/api/announcement/create';
    modelBase.post(successCallBack, failureCallBack, path, { body: params });
  }
}

export default announcementModel;
